'use client';

import React from 'react';

interface ModalProps {
  isOpen: boolean;
  modalComponent: React.ReactNode;
}

/**
 * [共通]確認モーダルコンポーネント
 * @param param0
 * @returns
 */
const ConfirmModal: React.FC<ModalProps> = ({ isOpen, modalComponent }) => {
  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black opacity-50 z-50"></div>}
      {isOpen && modalComponent}
    </>
  );
};

export default ConfirmModal;
